import { inject, injectable } from "@launchtray/tsyringe-async";
import { Language } from "../../localization/Localization";
import { SettingsModel } from "../models/SettingsModel";
import { SaveModel } from "../models/SaveModel";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { IGameDistributionSdk } from "../../gamedistribution/interfaces/IGameDistributionSdk";

@injectable()
export class SettingsController {
    public constructor(
        private readonly settingsModel: SettingsModel,
        private readonly saveModel: SaveModel,
        @inject(InjectableInterfaces.IGameDistributionSdk) private readonly gdSdk: IGameDistributionSdk
    ) {
    }
    
    public changeLocalization(language: Language): void {
        this.settingsModel.changeLanguage(language);
    }

    public setMusicEnabled(value: boolean): void {
        this.settingsModel.setMusicEnabled(value);
    }

    public setSfxEnabled(value: boolean): void {
        this.settingsModel.setSfxEnabled(value);
    }

    public resetGameProgress(): void {
        this.saveModel.clearGameStorage();
        window.location.reload();
    }

    public async showMidrollAd(): Promise<void> {
        return await this.gdSdk.showMidrollAd();
    }
}
